import { useDashboardData } from "@hooks";

const useManagerData = (params) => {
  return useDashboardData("/user/dash/manager", "managerData", params, "get");
};

export default useManagerData;
